import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as courier from './CourierRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({courier: state.courier})
const connector = connect(mapState, courier.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const CourierInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(CourierInit)
